export const ASOS_WORLD_LOCALIZED_PATHS = {
  COM: "discover/asos-world/",
  DE: "de/entdecken/asos-world/",
  US: "us/discover/asos-world/"
};

export const getAsosWorldUrl = storeCode => {
  return ASOS_WORLD_LOCALIZED_PATHS[storeCode || "COM"];
};
